import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>

      {/* TÍTULO PRINCIPAL */}
      <p className={style.titulo}>
        {t('Products.Smartsen.FirstPart.title')}
      </p>

      <div className={style.divContainer}>

        {/* COLUMNA IZQUIERDA */}
        <div className={style.divIzq}>
          <p className={style.text}>
            {t('Products.Smartsen.FirstPart.text2')}
          </p>

          <p className={style.text}>
            {t('Products.Smartsen.FirstPart.text3')}
          </p>

          <p className={style.text}>
            {t('Products.Smartsen.FirstPart.text4')}
          </p>
        </div>

        {/* COLUMNA DERECHA */}
        <div className={style.divDer}>
          <p className={style.title}>
            {t('Products.Smartsen.FirstPart.text7')}
          </p>

          <div className={style.separador}></div>

          <ul className={style.ul}>
            <li className={style.li}>
              {t('Products.Smartsen.FirstPart.text8')}
            </li>
            <li className={style.li}>
              {t('Products.Smartsen.FirstPart.text10')}
            </li>
          </ul>
        </div>

      </div>
    </div>
  )
}

export default PrimeraParte
